import { ref, watch, type Ref } from '@/composition/vue/compositionApi'
import { verifyImageWithCache } from '@/utils/imageVerification'

export const useUrlVerified = (url: Ref<string>) => {
  const urlVerifyed = ref(false)

  watch(
    () => url.value,
    () => {
      urlVerifyed.value = false

      if (!url.value) return

      verifyImageWithCache(url.value)?.then(() => {
        urlVerifyed.value = true
      })
    },
    { immediate: true },
  )

  return {
    urlVerifyed,
  }
}
